const key = (restaurantId) => `diningPlatformSession:${String(restaurantId || "").trim()}`;

function readRaw(restaurantId) {
  const rid = String(restaurantId || "").trim();
  if (!rid) return null;
  try {
    return sessionStorage.getItem(key(rid)) || localStorage.getItem(key(rid));
  } catch {
    return null;
  }
}

function writeRaw(restaurantId, value) {
  const rid = String(restaurantId || "").trim();
  if (!rid) return;
  try {
    if (value == null) {
      sessionStorage.removeItem(key(rid));
      localStorage.removeItem(key(rid));
      return;
    }
    sessionStorage.setItem(key(rid), value);
    localStorage.setItem(key(rid), value);
  } catch {
    /* ignore */
  }
}

/** @returns {{ sessionId: string, tableQrToken?: string, tableId?: string } | null} */
function readBinding(restaurantId) {
  const raw = readRaw(restaurantId);
  if (!raw) return null;
  if (/^[a-f0-9]{24}$/i.test(raw)) {
    return { sessionId: raw };
  }
  try {
    const o = JSON.parse(raw);
    const sessionId = String(o?.sessionId || "").trim();
    if (!sessionId) return null;
    const out = { sessionId };
    const tok = String(o?.tableQrToken || "").trim();
    if (tok.length >= 16) out.tableQrToken = tok;
    const tableId = String(o?.tableId || "").trim();
    if (tableId) out.tableId = tableId;
    return out;
  } catch {
    return null;
  }
}

/**
 * Persist dining session for a restaurant. When tableQrToken is set, the session
 * is scoped to that physical table (prevents Table 1 / Table 2 cross-talk).
 */
export function setDiningSessionId(restaurantId, sessionId, opts = {}) {
  const rid = String(restaurantId || "").trim();
  const sid = String(sessionId || "").trim();
  if (!rid || !sid) return;
  const payload = { sessionId: sid };
  const tok =
    typeof opts === "string"
      ? String(opts || "").trim()
      : String(opts?.tableQrToken || "").trim();
  if (tok.length >= 16) payload.tableQrToken = tok;
  const tableId = String(opts?.tableId || "").trim();
  if (tableId) payload.tableId = tableId;
  writeRaw(rid, JSON.stringify(payload));
}

/**
 * @param {string} restaurantId
 * @param {string} [tableQrToken] — when provided, only return session if it belongs to this table QR
 */
export function getDiningSessionId(restaurantId, tableQrToken) {
  const binding = readBinding(restaurantId);
  if (!binding?.sessionId) return null;
  const reqTok = String(tableQrToken ?? "").trim();
  if (reqTok.length >= 16) {
    const boundTok = String(binding.tableQrToken ?? "").trim();
    if (boundTok !== reqTok) return null;
  }
  return binding.sessionId;
}

export function getDiningSessionBinding(restaurantId) {
  return readBinding(restaurantId);
}

export function clearDiningSessionId(restaurantId) {
  writeRaw(String(restaurantId || "").trim(), null);
}
